/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.sherpa.activities.customer.controllers', [])

.controller('SherpaActivitiesCustomerController', ['$scope', function($scope) {

    $scope.sherpaActivitiesCustomer = "Your spankin new application.sherpa.activities.customer view!";

}]);